// Component: Card.jsx
// Purpose: DS Card primitive — the base surface (.ds-card) with optional hover
//          lift and padding variants, plus Card.Header / Card.Body / Card.Footer
//          slots. The bespoke card directions (monolithic/bento/etc.) are
//          page-level compositions built ON this primitive, not part of it.

import React, { forwardRef } from "react";
import { cx } from "./cx";

const PAD = { app: "", marketing: "pad-marketing", none: "pad-none" };

export const Card = forwardRef(function Card(
  { hover = false, pad = "app", className, children, ...props },
  ref
) {
  return (
    <div
      ref={ref}
      className={cx("ds-card", PAD[pad], hover && "card-hover", className)}
      {...props}
    >
      {children}
    </div>
  );
});

// --> Structural slots
const Header = ({ className, ...p }) => (
  <div className={cx("ds-card-header", className)} {...p} />
);
const Body = ({ className, ...p }) => (
  <div className={cx("ds-card-body", className)} {...p} />
);
const Footer = ({ className, ...p }) => (
  <div className={cx("ds-card-footer", className)} {...p} />
);

Card.Header = Header;
Card.Body = Body;
Card.Footer = Footer;

export default Card;
